// extracted by mini-css-extract-plugin
export default {"formContainer":"Form_formContainer__quths","formControl":"Form_formControl__qU1S0","input":"Form_input__FTtTw","buttons":"Form_buttons__MzqbX"};